<template>
  <div class="login-page">
    <div class="login-wrapper">
      <div v-if="error" class="error">
        {{$t('errors.' + error.code)}}
      </div>

      <form v-if="success == false" class="password-reset-form" @submit.prevent="resetPassword">
        <h2>{{$t('ui.auth.password_reset_title')}}</h2>
        <p class="subtitle">{{$t('ui.pages.password_reset')}}</p>
        <field label=" " name="token" type="hidden" v-model="token"></field>
        <field :placeholder="$t('ui.auth.password')" name="password" type="password" label="ui.auth.password" v-model="password"></field>
        <field :placeholder="$t('ui.auth.password_confirmation')" name="password_confirmation" type="password" label="ui.auth.password_confirmation" v-model="password_confirmation"></field>
        <div class="submit">
          <input type="submit" class='btn btn-primary btn-login' data-action="user.password_reset" :value="$t('ui.auth.confirm')"/>
        </div>
      </form>
      <div v-else class="password-reset-confirm">
        <h2>{{$t('ui.auth.password_reset_title_confirm')}}</h2>
        <p class="subtitle">{{$t('ui.pages.password_reset_confirm')}}</p>
        <img src="../../assets/success-password.svg">
      </div>
      <hr>
      <div class="actions">
        <router-link :to="{name:'login'}"><i class="icon yule-icon-chevron-left"></i> {{$t('ui.auth.return_to_login')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
import Auth from '@/api/Auth'

export default{
  components: {Field},
  metaInfo () {
    return {
      title: this.$t("ui.meta_info.reset_password")
    }
  },
  data(){
    return{
      password: '',
      password_confirmation: '',
      success: false,
      error: '',
      token: '',
    }
  },
  mounted(){
    this.token = this.$route.params.token
  },
  methods:{
    resetPassword(){
      let auth = new Auth()
      this.errros = []
      if(this.password == this.password_confirmation){
        if(this.password == ''){
          this.error = { code: 'authentication.empty_password'}
        }else if(!this.validatePassword(this.password)){
          this.error = { code: 'authentication.wrong_password'}
        }else{
          this.error = null
          auth.resetPassword(this.token,this.password,this.password_confirmation,this.$i18n.locale).then(result=>{
            this.success = true
          }).catch(e=>{
            this.error = e.response.data.errors[0]
          })
        }
      }else{
        this.error = {code: 'authentication.wrong_password_confirmation'}
      }
    },
    validatePassword(password){
      if(password.length < 8){
        return false
      }
      let numberRegex = /[0-9]/
      if(!numberRegex.test(password)){
        return false
      }
      let letterRegex = /[a-z]/
      if(!letterRegex.test(password)){
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss">
.password-reset-form{
  margin-top: 120px;
  margin-bottom: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .submit {
    margin-top: 0 !important;
  }

}
  .icon{
    vertical-align: text-top;
    font-size: 18px;
  }
.illustration{
  display: block;
  margin: 20px auto;
}
.password-reset-confirm{
  text-align: center;
  padding: 80px 0;
}
</style>



// WEBPACK FOOTER //
// PasswordReset.vue?388a7d0a